'use strict';

var React = require('react');

var SVG = React.createClass({
  displayName: 'SVG',

  render: function render() {
    return React.createElement('svg', this.props);
  }
});

module.exports = SVG;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/graphics/svg.js
 **/